import { useOutletContext } from 'react-router-dom'
import type { AppShellContext } from '../components/AppShell'
import { DeskGrid } from '../components/desk/DeskGrid'
import {
  ActivityModule,
  BooksModule,
  DrawdownFloorModule,
  EngineAlarmsModule,
  ExposureModule,
  FleetEquityModule,
  FleetPnlModule,
  FleetValueModule,
  PicksExcessModule,
  PicksHorizonsModule,
  PipelineModule,
  SectorModule,
} from '../components/desk/FleetModules'
import { useBooks } from '../hooks/useBooks'
import { useIsMobile } from '../hooks/useMediaQuery'
import { FleetLegacyBody } from './FleetLegacyBody'

/**
 * Command view. Desktop: a no-scroll DeskGrid of twelve summary modules
 * (row 1: six stat tiles; row 2: fleet value + picks by horizon; row 3:
 * books, pipeline, sectors, activity); each opens its drawer. Phone keeps
 * the legacy picks-first zones (FleetLegacyBody).
 */
export function FleetPage() {
  // Hooks run unconditionally, before the phone branch.
  const { ws } = useOutletContext<AppShellContext>()
  const isMobile = useIsMobile()
  const { books, byRole, isLoading: booksPending, isError: booksError } = useBooks()

  if (isMobile) return <FleetLegacyBody ws={ws} />

  const research = byRole('research')
  const fleet = { books, booksPending, booksError }

  return (
    <main className="dashboard-content desk-page fleet-page">
      <DeskGrid>
        <FleetEquityModule {...fleet} />
        <FleetPnlModule {...fleet} />
        <PicksExcessModule {...fleet} />
        <DrawdownFloorModule {...fleet} />
        <ExposureModule {...fleet} />
        <EngineAlarmsModule {...fleet} />

        <FleetValueModule {...fleet} />
        <PicksHorizonsModule {...fleet} />

        <BooksModule {...fleet} />
        <PipelineModule research={research} booksPending={booksPending} />
        <SectorModule research={research} booksPending={booksPending} />
        <ActivityModule ws={ws} />
      </DeskGrid>
    </main>
  )
}
